/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "오른쪽에서 왼쪽으로",
		"timeZoneID": "시간대",
		"skin": "스타일",
		"metricsFileImportTask": "새 파일에서 가져오기",
		"displayMode": "기본 보기",
		"credentialRenewed": "신임 정보가 현재 사용자 ID 및 비밀번호로 갱신되었습니다.",
		"productLocale": "제품 언어",
		"toggleDisabled": "해제",
		"credentialChange": "갱신",
		"log_level_Debug": "디버그",
		"confirmNewPassword": "새 비밀번호 확인",
		"unsavedViewMsg2": "먼저 저장하지 않으면 변경사항이 손실됩니다.",
		"supportPortalErrorMessage": "다시 시도하십시오.  문제점이 지속되면 관리자에게 문의하십시오.",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, IBM 로고, ibm.com 및 Cognos는 전세계 여러 국가에 등록된 International Business Machines Corp.의 상표 또는 등록상표입니다. 현재 IBM 상표 목록은 웹(www.ibm.com/legal/copytrade.shtml)에 있습니다. 본 프로그램은 본 프로그램에 동봉된 라이센스 계약에 의하여 라이센스가 부여됩니다. 본 라이센스 계약은 본 프로그램 디렉토리 폴더 또는 라이브러리의 \"License\" 또는 \"Non_IBM_License\" 파일 안에 존재하거나, 해당되는 경우, 인쇄물로서 제공됩니다. 본 프로그램을 사용하기 전에 본 계약을 주의깊게 읽으십시오. 본 프로그램을 사용하는 경우 귀하는 본 계약에 동의한 것으로 간주됩니다.",
		"groupsAndRoles": "그룹 및 역할",
		"metricsMaintenanceTask": "새 유지보수",
		"email": "이메일",
		"contextual": "컨텍스트",
		"resetHome": "기본값으로 재설정",
		"ltr": "왼쪽에서 오른쪽으로",
		"credentials": "신임 정보",
		"logging_congfig_title": "로깅",
		"changePasswordTitle": "내 비밀번호 변경",
		"format": "보고서 형식",
		"showUnread": "읽지 않음 표시",
		"AILearning_active": "AI 학습이 활성화되어 있음:",
		"docsErrorMessage": "다시 시도하십시오.  문제점이 지속되면 관리자에게 문의하십시오.",
		"toggleEnabled": "설정",
		"homeSetError": "기본 홈 페이지를 설정하는 중에 오류가 발생했으니 이 보기를 닫고 다시 여십시오.",
		"passwordChange": "비밀번호 변경",
		"profile": "프로파일",
		"pdfRestricted": "PDF(제한됨)",
		"drillThrough": "드릴 스루 정의",
		"homeSet": "홈이 설정됨",
		"regionalOptions": "국가별 옵션",
		"myPreferences": "내 환경 설정",
		"defaultHome": "기본값",
		"version": "버전",
		"controller": "Controller",
		"manage": "관리",
		"biDirectionalFeaturesEnabled": "양방향 언어 지원",
		"newFeaturesErrorTitle": "새 기능에 대한 링크가 작동하지 않음",
		"passwordMatch": "비밀번호 일치",
		"updateProfileAndsettings": "프로파일 및 설정 업데이트",
		"dashboardConsole": "작업공간",
		"legacyAppsSlideoutLabel": "사용 가능한 레거시 애플리케이션",
		"logging_config_description": "로깅은 문제점 해결에 사용됩니다. 설정에 대한 안내는 관리자에게 문의하십시오.",
		"confirmDeletion": "삭제 확인",
		"signInButtonText": "로그인",
		"dataSourceCredentials": "데이터 서버 신임 정보",
		"AILearningConfigurationSlideoutAllyLabel": "AI 학습 구성",
		"loadingSettings": "설정 로드 중",
		"spreadsheetMLRestricted": "Excel(제한됨)",
		"manageAILearning": "AI 학습",
		"xlsxDataRestricted": "Excel 데이터(제한됨)",
		"advanced": "고급 옵션",
		"ok": "확인",
		"changeEmail": "변경",
		"showHints": "힌트 표시",
		"general": "일반",
		"xlsxData": "Excel 데이터",
		"newPassword": "새 비밀번호",
		"hideAll": "모두 숨기기",
		"confirmPassword": "비밀번호 확인",
		"AILearning_config_description": "Cognos Analytics에서 사용자의 사용법을 학습하게 하여 제품 내 권장사항을 개선하십시오.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "지원 포털에 대한 링크가 작동하지 않음",
		"log_level_Warn": "경고",
		"contentSettings": "컨텐츠 설정",
		"setHomeButton": "세트",
		"myCapabilities": "내 기능",
		"homePage": "홈 페이지",
		"helpErrorMessage": "다시 시도하십시오.  문제점이 지속되면 관리자에게 문의하십시오.",
		"loadingProfile": "프로파일 로드 중",
		"portal": "포털",
		"metricsPackage": "새 패키지",
		"myCredentials": "내 신임 정보",
		"credentialCreate": "작성",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "비밀번호를 업데이트할 수 없음",
		"showHiddenObjects": "숨겨진 항목 표시",
		"csv": "CSV",
		"docsErrorTitle": "문서에 대한 링크가 작동하지 않음",
		"log_level_Error": "오류",
		"wrongPassword": "인증할 수 없음",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "정보",
		"welcomeBanner": "시작 배너",
		"helpErrorTitle": "도움말에 대한 링크가 작동하지 않음",
		"contentLocale": "컨텐츠 언어",
		"pdf": "PDF",
		"oldPassword": "이전 비밀번호",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "내게 필요한 옵션 기능",
		"manageLogging": "로깅",
		"loggingConfigurationSlideoutA11yLabel": "로깅 구성",
		"communityErrorTitle": "커뮤니티에 대한 링크가 작동하지 않음",
		"companionApps": "동반 애플리케이션",
		"setHomeLabel": "홈 설정(현재 보기)",
		"metricsExportTask": "새 내보내기",
		"csvRestricted": "CSV(제한됨)",
		"newFeaturesErrorMessage": "다시 시도하십시오.  문제점이 지속되면 관리자에게 문의하십시오.",
		"contributor": "Contributor",
		"showAll": "모두 표시",
		"logging_active": "로깅 설정 날짜:",
		"html": "HTML",
		"profileAndSettings": "프로파일 및 설정",
		"baseTextDirection": "텍스트의 기본 방향",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "비밀번호",
		"invalidEmail": "올바른 이메일 주소 입력",
		"credentialCreateSuccess": "신임 정보를 작성함",
		"settings": "설정",
		"restrictedFormatSelected": "이 형식으로 보고서를 실행할 기능이 없지만 이 형식으로 저장된 보고서에 액세스할 수 있습니다.",
		"usageDataDeletionConfirmation": "사용법 데이터를 삭제하면 AI 학습이 재설정됩니다.  사용법 데이터를 삭제하시겠습니까?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "세부사항 보기",
		"deleteUsageData": "사용법 데이터 삭제:",
		"showPassword": "비밀번호 표시",
		"AILearning_config_title": "AI 학습",
		"myPreferencesSlideoutLabel": "프로파일 및 설정",
		"passWordChangeSuccess": "비밀번호가 성공적으로 변경됨",
		"logging_level": "로깅 레벨:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "다시 시도하십시오.  문제점이 지속되면 관리자에게 문의하십시오.",
		"cancel": "취소",
		"shareSetError": "이 조치는 이 보기를 닫고 다시 열기 전에 수행할 수 없습니다.",
		"passwordNotMatch": "비밀번호가 일치하지 않음",
		"xml": "XML",
		"xmlRestricted": "XML(제한됨)",
		"openMenu": "메뉴 열기",
		"closeMenu": '메뉴 닫기'
});